export function makeLevelKey(worldId: string, levelId: string): string {
  return `${worldId}:${levelId}`;
}

export function matchesLevelKey(
  key: string,
  worldId: string,
  levelId: string
): boolean {
  return key === makeLevelKey(worldId, levelId) || key === levelId;
}

